import axios, { AxiosResponse } from 'axios'
import { ID, Response } from '../../../../../../_metronic/helpers'
import { User, UsersQueryResponse } from './_models'

const API_URL = process.env.REACT_APP_BASE_API_URL
const USER_URL = `${API_URL}`
const GET_USERS_URL = `${API_URL}`

const getUsers = (query: string, initialApi: string = 'users'): Promise<UsersQueryResponse | any> => {
  const urlParams = new URLSearchParams(query)
  const typeParam = urlParams.get('type')

  if (typeParam === 'MANUFACTURING_UNIT,RECYCLER') {
    const types = typeParam.split(',')

    const requests = types.map(t => {
      const params = new URLSearchParams(query)
      params.set('type', t)
      const newQuery = params.toString()

      const base = GET_USERS_URL + initialApi
      const baseUrl = `${base}${base.includes('?') ? '&' : '?'}${newQuery}`
      return axios.get(baseUrl).then((d: AxiosResponse<any>) => d?.data?.data ? d.data : d)
    })

    return Promise.all(requests).then(responses => {
      let mergedData: any[] = []
      let mergedMeta: any = null

      responses.forEach(res => {
        // Axios wraps the response in `data`, and our interceptor/mapper logic above returns `d.data` if it has `d.data.data`
        const resData = res?.data || res

        if (Array.isArray(resData)) {
          mergedData = [...mergedData, ...resData]
        } else if (resData && Array.isArray(resData.data)) {
          // If it's an object with a data array
          mergedData = [...mergedData, ...resData.data]
          if (resData.meta) mergedMeta = resData.meta
        } else if (res && Array.isArray(res.data)) {
          // Fallback
          mergedData = [...mergedData, ...res.data]
          if (res.meta) mergedMeta = res.meta
        }
      })

      if (mergedMeta) {
        return { data: mergedData, meta: mergedMeta }
      }
      return { data: mergedData }
    })
  }

  const base = GET_USERS_URL + initialApi
  const baseUrl = `${base}${base.includes('?') ? '&' : '?'}${query}`
  return axios.get(baseUrl).then((d: AxiosResponse<any>) => {
    return d?.data?.data ? d.data : d
  })
}

const getUserById = (id?: any, api: any = ''): Promise<User | undefined> => {
  return axios
    .get(`${GET_USERS_URL + api || USER_URL}${id || ''}`)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data || response)
}

const createUser = (user: User, url?: any): Promise<User | undefined> => {
  console.log({ user, url })
  const baseURL = url.includes('http') ? url : url ? USER_URL + url : USER_URL
  return axios
    .post(baseURL, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}

const updateUser = (user: User, url?: any): Promise<User | undefined> => {
  const baseURL = url.includes('http') ? url : url ? USER_URL + url : USER_URL
  return axios
    .put(baseURL, user)
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}



// for delete
const updateUser2 = (url?: any): Promise<User | undefined> => {
  const baseURL = url.includes('http') ? url : url ? USER_URL + url : USER_URL
  return axios
    .put(baseURL, null, {
      headers: {
        // Your headers here if needed
      }
    })
    .then((response: AxiosResponse<Response<User>>) => response.data)
    .then((response: Response<User>) => response.data)
}



const deleteUser = (userId: ID): Promise<void> => {
  return axios.delete(`${USER_URL}/${userId}`).then(() => { })
}

const deleteSelectedUsers = (userIds: Array<ID>): Promise<void> => {
  const requests = userIds.map((id) => axios.delete(`${USER_URL}/${id}`))
  return axios.all(requests).then(() => { })
}

export { getUsers, deleteUser, deleteSelectedUsers, getUserById, createUser, updateUser, updateUser2 }
